import React from 'react';
import { Box } from '@mui/material';
import { layoutStyle } from '@layout/styles';
import { TranslationAdapter, UserFeedbackButton } from '@g2-shared/common';

interface Props {
  children: React.ReactNode;
}

function WuLayoutContentWrapper({ children }: Props) {
  const { t } = TranslationAdapter();
  return (
    <Box sx={layoutStyle.layoutContentWrapper}>
      {children}
      {!import.meta.env.PROD && <UserFeedbackButton label={String(t('Report_feedback'))} />}
    </Box>
  );
}

export default WuLayoutContentWrapper;
